<template>
  <div>
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <Nav />
    <router-view :encuestas="datosEncuesta" router-view/>
    <Footer />
  </div>
</template>

<script>

import firebaseApp from "@/firebase/firebase.js";
import { getDatabase, ref, onValue } from "firebase/database";
import Catalogo from './components/Catalogo.vue'
import Nav from './components/shared/Nav.vue'
import Footer from './components/shared/Footer.vue'

export default {
  name: 'App',
  data(){
    return{
      datosPop: {},
      datosEncuesta: {}
    }
  },
  components: {
    Catalogo,
    Nav,
    Footer
  },
  methods: {
    obtenerEncuestas() {
      const db = getDatabase();
      const dbRef = ref(db, "encuesta");
      //console.log(dbRef);
      try {
        onValue(
          dbRef,
          (snapshot) => {
            //console.log(snapshot);
            let encuestas = JSON.parse(JSON.stringify(snapshot));
            //console.log(encuestas);
            this.datosEncuesta = encuestas;
            
          },
          {
            onlyOnce: true,
          }
        )
      }catch(e){
        console.error(e);
      }
    },
  },
  created() {
    this.obtenerEncuestas();
  },
}
</script>

<style lang="scss">

#app {
  background-color: #050607;
  color: #ffffff;
  font-family: "Fredoka", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  min-height: 100vh;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  position: relative;
}

#app:before,
#app:after {
  background: url("~@/assets/header-assets/brush4.webp") center / contain no-repeat;
  content: "";
  opacity: 0.24;
  pointer-events: none;
  position: absolute;
  width: min(58vw, 680px);
  z-index: 0;
}

#app:before {
  height: min(38vw, 440px);
  left: max(-15rem, calc(50% - 42rem));
  top: calc(50% - 12rem);
  transform: translateY(-50%);
}

#app:after {
  height: min(42vw, 500px);
  right: max(-15rem, calc(50% - 42rem));
  top: calc(50% + 12rem);
  transform: translateY(-50%) scaleX(-1);
}

#app > * {
  position: relative;
  z-index: 1;
}

html,
body {
  background-color: #050607 !important;
  min-height: 100%;
}

body {
  background-image: url("~@/assets/header-assets/noise.svg");
  background-repeat: repeat;
  margin: 0;
  min-height: 100vh;
}

@media (max-width: 767px) {
  #app:before,
  #app:after {
    opacity: 0.2;
    width: 28rem;
  }

  #app:before {
    height: 17rem;
    left: -16rem;
    top: calc(50% - 7rem);
  }

  #app:after {
    height: 18rem;
    right: -16rem;
    top: calc(50% + 7rem);
  }
}
 
</style>
